import React from 'react';

import InfoIcon from 'assets/icons/info.png';

const Icon = (props) => {
  return (
    <div
      className="hotspot_icon"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        background: '#dd3738',
        borderRadius: '50%',
        zIndex: 2,
        position: 'relative',
        border: '2px solid #fff',
      }}
    >
      <img alt="info-icon" src={InfoIcon} style={{ width: '7px' }}></img>
    </div>
  );
};

export default Icon;
